/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { TViewComponent } from "../../../view/IView";
import { RoutesEditor } from "./RoutesEditor";
import { Layout } from "../../../ui/components/Layout/Layout";
import { RoutesEditorMain } from "./components";
import { RoutesEditorToolbar } from "./components/RoutesEditorToolbar";

export const RoutesEditorComponent: TViewComponent<RoutesEditor> = ({ view }) => {
	const layoutState = useMemo(() => view.getLayout(), []);

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "mainToolbar":
				return <RoutesEditorToolbar view={view} />;
			case "main":
				return <RoutesEditorMain view={view} />;
			default:
				return <p>Error: Undefined panel {componentName}.</p>;
		}
	};

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
